import { render, staticRenderFns } from "./IndexModalEdit.vue?vue&type=template&id=1e81ded2"
import script from "./IndexModalEdit.vue?vue&type=script&lang=js"
export * from "./IndexModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports